import { Conditional } from '@consumidor-positivo/aurora';
import { OfferSkeleton } from '@libs/creditkit';

import { MainOfferCard } from '../MainOfferCard';
import { FeaturedOfferTemplate as Template } from './Template';
import { FeaturedOffersCarousel as Carousel } from './components/Carousel';
import { OfferFeaturedProps } from './types';
import { useGetOffers } from '@hub/hooks/useGetOffers';

import './styles.scss';

export const OfferFeatured = ({ location, forceDecide, onClickOffersCTA, blockTitle, withIlustration }: OfferFeaturedProps) => {
  const { redirectToOffers, SHLoading, noOffer, decideDone, featuredOffers } = useGetOffers({ callSHDecide: forceDecide });

  const title = blockTitle ? blockTitle : 'Você tem ofertas liberadas te esperando';

  return (
    <Template
      title={title}
      noOffer={noOffer}
      withIlustration={withIlustration}
      onClickMoreOffersBtn={() => {
        redirectToOffers();
        onClickOffersCTA && onClickOffersCTA();
      }}
    >
      <Conditional
        condition={SHLoading || !decideDone}
        renderIf={
          <div className="offer-featured__skeleton">
            <OfferSkeleton />
          </div>
        }
        renderElse={
          <Carousel>
            {featuredOffers?.slice(0, 2).map((offer, index) => (
              <div className="offer-featured__card-container" key={`offer-filtered-card__${offer?.content?.slug}-${index}`}>
                <MainOfferCard index={index} location={location} offer={offer} />
              </div>
            ))}
          </Carousel>
        }
      />
    </Template>
  );
};
